import { useTranslation } from 'react-i18next'
import styles from './DateSelector.module.css'

interface DateSelectorProps {
  date: string       // ISO YYYY-MM-DD
  onChange: (date: string) => void
  maxDate: string    // ISO YYYY-MM-DD — right arrow hidden when date >= maxDate
}

function shiftDate(isoDate: string, days: number): string {
  const d = new Date(isoDate + 'T12:00:00Z') // use noon UTC to avoid DST issues
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

function formatDate(isoDate: string): string {
  const d = new Date(isoDate + 'T12:00:00Z')
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}

export default function DateSelector({ date, onChange, maxDate }: DateSelectorProps) {
  const { t } = useTranslation()
  const canGoForward = date < maxDate

  return (
    <div className={styles.wrapper} role="group" aria-label={t('date_selector_label')}>
      <button
        type="button"
        className={styles.arrow}
        onClick={() => onChange(shiftDate(date, -1))}
        aria-label={t('date_previous_day')}
        title={t('date_previous_day')}
      >
        ‹
      </button>

      <span className={styles.dateLabel}>{formatDate(date)}</span>

      {canGoForward ? (
        <button
          type="button"
          className={styles.arrow}
          onClick={() => onChange(shiftDate(date, 1))}
          aria-label={t('date_next_day')}
          title={t('date_next_day')}
        >
          ›
        </button>
      ) : (
        <span className={styles.arrowPlaceholder} aria-hidden="true" />
      )}
    </div>
  )
}
